import { render, staticRenderFns } from "./indonesia.vue?vue&type=template&id=68adfae6&scoped=true"
import script from "./indonesia.vue?vue&type=script&lang=js"
export * from "./indonesia.vue?vue&type=script&lang=js"
import style0 from "./indonesia.vue?vue&type=style&index=0&id=68adfae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68adfae6",
  null
  
)

export default component.exports